import React from 'react';
import ProductForm from './ProductForm';
import { useSelector } from 'react-redux';

const RefactoredEditProduct = ({ productId, clientId, onSuccess, onCancel }) => {
  const selectedClients = useSelector((state) => state.selectedClients);
  
  const effectiveClientId = clientId || (selectedClients && selectedClients[0]);
  
  const handleSuccess = (data) => {
    if (onSuccess) {
      onSuccess(data);
    }
  };

  return (
    <div className="">
      <div className="row">
        <div className="col-12">
          <ProductForm
            productId={productId}
            clientId={effectiveClientId}
            onSuccess={handleSuccess}
            onCancel={onCancel}
          />
        </div>
      </div>
    </div>
  );
};

export default RefactoredEditProduct;
